// react imports
import React from 'react';

const NormalInput = props => {
  // props
  const { label, type, defaultValue, name, register, errors, ...rest } = props;

  return (
    <div className="">
      <label
        htmlFor={name}
        className="block text-sm font-medium  dark:text-gray-200"
      >
        {label || 'Normal Input'}
      </label>
      <input
        type={type || 'text'}
        defaultValue={defaultValue}
        {...rest}
        {...register(name)}
        className={`w-full mt-1 form-input placeholder:text-sm dark:placeholder:text-gray-400 ${
          errors
            ? 'border-red-500 focus:ring-red-500 dark:border-red-600 dark:focus:ring-red-600'
            : ''
        }`}
      />
      {errors && <p className="mt-2 text-xs text-red-500">{errors}</p>}
    </div>
  );
};

export default NormalInput;
